import request from "@/utils/request";

let Api = {
  /*小程序*/
  /* getData(data) {
    return request._get('/shop/plus.api.app/index', data);
  },
  applyData(data) {
    return request._post('/shop/plus.api.app/index', data);
  }, */
  /* 获取数据 */
  getData(data) {
    return request._get("/shop/plus.api.api/index", data);
  },
  /* 获取接口类型 */
  getApiType(data) {
     return request._get("/shop/plus.Apitype.Apitype/index", data);
    
  },
  /* 获取接口列表 */
  getApiList(data) {
    
    return request._get("/shop/plus.api.api/index", data);
  },
  /*编辑Api*/
  editApi(data) {
    return request._post("/shop/plus.plugins.index/edit_api", data);
  },
  /*添加Api*/
  addApi(data) {
    return request._post("/shop/plus.plugins.index/add_api", data);
  },
  /*删除到回收站Api*/
  deleteApi(data) {
    return request._post("/shop/plus.api.api/delete", data);
  },
  /* 彻底删除Api */
  dellApi(data) {
    return request._post("/shop/plus.plugins.index/dell_api", data);
  },
  /*通讯检测*/
  checkApi(data) {
    return request._post("/shop/plus.plugins.index/status_api", data);
  },
  /*同步Api*/
  synckApi(data) {
    return request._post("/shop/plus.plugins.index/sync_api", data);
  },
  /*baota login Api*/
  loginApi(data) {
    return request._post("/shop/plus.plugins.index/_call", data);
  },
  /* 获取动态表单子项 */
  getApiPlugin(data) {
    return request._post("/shop/plus.plugins.index/get_api", data);
  },
  /* 恢复删除Api */
  recoveryApi(data) {
    return request._post("/shop/plus.plugins.index/recovery_api", data);
  }
};

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js